// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"RoundAvatar_avatarWrapper__6gwvk","initialWrapper":"RoundAvatar_initialWrapper__HryM9"};